import {PhaseDto} from '../../lib/dtos/PhaseDto';

export const getCurrentPhase = (phases: PhaseDto[]): number | undefined => {
    const firstUnCompleted = phases.find((phase) => !phase.completed);
    return firstUnCompleted && firstUnCompleted.phaseId;
};
